export default __webpack_public_path__ + "static/media/prod-img-8.284e9cb5.webp";